import { render, staticRenderFns } from "./banklookupiframe_.vue?vue&type=template&id=61dea59a"
import script from "./banklookupiframe_.vue?vue&type=script&lang=js"
export * from "./banklookupiframe_.vue?vue&type=script&lang=js"
import style0 from "./banklookupiframe_.vue?vue&type=style&index=0&id=61dea59a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports